import  { 	CARGAR_NOTADEBITO, INICIALIZAR_NOTADEBITO } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargar_NotaDebitoPorCodigo = (idNotaDebito) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/notasdebito/' + idNotaDebito
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let notaDebito = response.data;
			dispatch({
				type: CARGAR_NOTADEBITO,
				data: notaDebito
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar nota de débito', mensaje: msgError}
			});
		});
	}
}

export const cargar_NotaDebitoPorNumero = (establec, ptoEmision, numero) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/notasdebito/${establec}/${ptoEmision}/${numero}`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let notaDebito = response.data;
			dispatch({
				type: CARGAR_NOTADEBITO,
				data: notaDebito
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar nota de débito', mensaje: msgError}
			});
		});
	}
}

export const inicializarNotaDebito = () => {	
	return {
		type: INICIALIZAR_NOTADEBITO,
		data: {}
	};
}